<template>
  <el-card class="quotes-detail-location-and-date"
           shadow="never">

    <div slot="header">
      <slot></slot>
    </div>

    <!-- LOCATION -->
    <div class="line">
      <el-link :href="`https://www.google.com/maps/search/?api=1&query=${locationEncoded}`"
               icon="el-icon-location-outline"
               target="_blank"
               type="primary">
        {{ location }}
      </el-link>
    </div>

    <!-- DATE -->
    <div class="line">
      <i class="el-icon-date"></i>
      {{ value.earliestDate | date('v') }}
      <el-tag effect="dark"
              size="mini"
              type="warning"
              v-if="!value.flexibleDate">
        {{ $t('QUOTES_DETAIL_LOCATION_AND_DATE.IS_NOT_FLEXIBLE') }}
      </el-tag>
    </div>

  </el-card>
</template>

<script>
export default {
  name: 'QuotesDetailLocationAndDate',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    location () {
      return `${this.value.address.locality}, ${this.value.address.regionName}, ${this.value.address.countryName}`
    },
    locationEncoded () {
      return encodeURIComponent(this.location)
    }
  }
}
</script>

<style lang="scss" scoped>
.quotes-detail-location-and-date {
  .line {
    font-size: 14px;
  }

  .line + .line {
    margin-top: 0.5rem
  }
}
</style>
